<!--
CONSULTA VAREJO PENDENCIAS CLIENTE
-->

<template>
  <div class="container-full-width default-container p-3">
    <filtro :showfiltro="showfiltro" :params="paramsFiltro" @change="filtroChange" @cancel="showfiltro = false">
    </filtro>

    <div class="row">
      <div class="col-12 mb-2">
        <span class="lbl-deal-title mb-2 w-100">CONSULTA CONTROLE PENDENCIAS CLIENTE</span>
      </div>
    </div>
    <hr v-if="!showDetalhe" />
    <div v-if="!showDetalhe" class="row mb-3 align-items-center">
      <div class="col-md-6 col-12">
        <v-button label="Filtro" :success="true" @click="handleShowFiltro"></v-button>
      </div>
    </div>

    <hr />


    <div v-if="!showDetalhe" class="default-container position-relative">
      <alert v-if="dados.length == 0" type="norecord"></alert>
      <div class="mainbox" v-for="(item, index) in dados" v-bind:key="index">
        <div class="box d-flex flex-wrap">
          <div class="col-md-6 col-6">
            <v-label v-if="index == 0" class="w-100" label="Cliente"></v-label>
            <span class="data-list">{{ item.nome }} </span>
          </div>
          <div class="col-md-2 col-2 text-right">
            <v-label v-if="index == 0" class="w-100" label="Quantidade"></v-label>
            <span class="data-list">R$ {{ item.qt | formatValue(2) }}</span>
          </div>
          <div class="col-md-2 col-2 text-right">
            <v-label v-if="index == 0" class="w-100" label="Valor"></v-label>
            <span class="data-list">R$ {{ item.valor | formatValue(2) }}</span>
          </div>
          <div class="col-md-2 col-2 align-items-right ml-auto">
            <bar-grid :obj="item" :options="handleBarGrid(item)" :moreActions="getActions(item)" @action="handleAction"
              @view="handleView(item)">
            </bar-grid>
          </div>

        </div>
      </div>
    </div>


    <ConsultaVarejoPendcliDet v-if="showDetalhe" :detalhe="this.detalhe" :codvabertura="this.codvabertura"
      @closeform="closeView" />
  </div>
</template>

<script>
import Chart from "./chart";
import Filtro from "./filtro";
import { apiORDSpost } from "../shared/api-functions";
import { apiDownload2 } from "../shared/api-functions";
import ConsultaVarejoPendcliDet from './consulta-varejo-pendcli-det.vue'

export default {
  props: {
    codvabertura: null,
  },


  components: {
    Filtro,
    Chart,
    ConsultaVarejoPendcliDet
  },

  data() {
    return {
      showfiltro: false,
      showDetalhe: false,

      dados: {},
      detalhe: {},


      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {
        periodo: {
          label: "Período",
          varios: false,
          data_inicio: null,
          data_termino: null,
        },
        filtros: [
          { nome: "filial", label: null, url: null, varios: false, values: [] },
          { nome: "cliente", label: null, url: null, varios: false, values: [] },
        ],
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }],
      },


      colunas: [
      ],

      mounting: false,

    };
  },

  watch: {},

  methods: {
    handleView(item) {
      console.log(item)
      this.detalhe = item
      this.showfiltro = false;
      this.showDetalhe = true;
    },

    closeView() {
      this.showfiltro = false;
      this.showDetalhe = false
      this.loadData()
    },


    handleAction(act, obj) {
      //if (act == 21) {
      //  this.handleEdit(obj.codpedv)
      //}
    },


    handleBarGrid(item) {
      let options = { barDefault: true, btnView: true, btnEdit: false, }

      return options
    },

    getActions(pedv) {
      let actions = []

      // actions.push({ action: 21, label: 'Visualização' })
      return actions
    },


    handleShowCaixa() {
      this.$router.push('/varejo/controlependenciacliente')
    },
    clickRetornar() {
      this.$router.push('/painelvarejo')
    },

    handleShowFiltro() {
      this.showfiltro = true;
    },

    filtroChange(filtro) {
      this.showfiltro = false;
      this.filtro = filtro;
      this.paramsFiltro.filtros[0].values = this.filtro.filial

      this.loadData();
    },

    async loadData(excel) {

      let url = "consulta/vendas/varejopendenciacliente";

      this.filtro.excel = excel;

      if (excel)
        apiDownload2(this, url, this.filtro, "post")
      else {
        this.mounting = true
        const data = await apiORDSpost(this.$store, url, this.filtro, "post")
        if (data) {
          this.dados = data
        }
      }
      this.mounting = false
    },

  },

  computed: {
  },

  mounted() {

  },

  created() {
    this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate())
    this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate())
    this.loadData()
  },
}


</script>

<style>
table .numerico {
  min-width: 65px;
  text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .size100 {
  width: 100px;
}

table .total {
  background: #c1c4c7;
  border: none;
}

table .var {
  min-width: 85px;
  text-align: center;
  background: #c1c4c7;
  display: inline-block;
}

table .var-negative {
  color: white;
  background: indianred;
}

table .var-positive {
  color: white;
  background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.consulta__total {
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta__total_valor {
  font-size: 40px;
  display: block;
  line-height: normal;
}

.consulta__cifrao {
  font-size: 16px;
  display: block;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/consultas/consulta-varejo-pendcli.vue